import React from "react";
import user_pic from "../../assets/images/avatar.png";

const AvatarPicture = ({ image, alt, size }) => {
  return (
    <div
      style={{
        width: `${size}px`,
        height: `${size}px`,
        borderRadius: "50%",
        overflow: "hidden",
      }}
    >
      <img
        src={image ? image : user_pic}
        className="img-fluid"
        alt={alt}
        styles={{ width: "100%", height: "auto" }}
      />
    </div>
  );
};

export default AvatarPicture;
